import Sockette from 'sockette'
import { useChatStore } from '@/stores/chat'
import { dispatchActions } from '@/composables/chat/useWebSocketDispatch'
import useChat from '@/composables/chat/useChat'
import WebSocketStatus from '@/views/chat/components/Utils/WebSocketStatus.vue'

const store = useChatStore()

/**
 * @type {Sockette|null}
 */
let websocket = null
const websocketStatusOk = ['connected']

/**
 * @param {String} path
 * @param {String} token
 * @param {Boolean} forceConnection
 */
export const startWebSocket = (path, token, forceConnection = false) => {
    let url = `${path}?token=${token}`

    store().websocket.path = path
    if (forceConnection) url += '&force=true'

    websocket = new Sockette(url, {
        timeout: 5e3,
        maxAttempts: 15,
        onopen: () => updateWebsocketStatus('connected'),
        onmessage: e => dispatchMessage(e),
        onreconnect: () => updateWebsocketStatus('reconnect'),
        onmaximum: () => { updateWebsocketStatus('limit') },
        onclose: () => {
            //useChat.openModal('', WebSocketStatus, true)
            updateWebsocketStatus('close')
        },
        onerror: () => updateWebsocketStatus('error'),
    })
}

export const closeWebsocket = () => {
    // if (websocket) {
    websocket.close()
    //}
}

/** @param {Object|String} message */
export const sendWebSocketMessage = (message) => {
    if (!websocket) {
        throw new Error('Conexão em tempo real indisponível. Aguarde a reconexão ou atualize a página.')
    }
    if (typeof message === 'string') {
        websocket.send(message)
        return
    }

    websocket.json(message)
}


// PRIVATES FUNCTIONS

/**
 * @param {MessageEvent} event WebSocket Message Event
 */
const dispatchMessage = (event) => {
    const data = JSON.parse(event.data)
    dispatchActions(data)
}

/**
 * @param {String} status 'connected' | 'reconnect' | 'limit' | 'close' | 'error'
 */
const updateWebsocketStatus = (status) => {
    store().updateWebsocketStatus(status)
}
